import { render, staticRenderFns } from "./CompanyStats.vue?vue&type=template&id=74d46399&scoped=true"
import script from "./CompanyStats.vue?vue&type=script&lang=js"
export * from "./CompanyStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d46399",
  null
  
)

export default component.exports